import React, {useState} from "react";
import {useForm} from "react-hook-form";
import {
    deleteControllablePrinterApiConnection,
    patchControllablePrinterApiConnection,
    postControllablePrinterApiConnection
} from "../../api/apiControllablePrinterApiConnection";

export const ConnectivityEiger = (props) => {
    const {
        currentUser,
        eigerConnectionId, setEigerConnectionId,
        eigerConnectionBrandId,
        successCallback, errorCallback
    } = props;

    const [isEigerConnectionUpdating, setIsEigerConnectionUpdating] = useState(false);

    const {handleSubmit, reset, register} = useForm();

    /* Form submission */
    const onSubmitEigerConnection = (data) => {
        data.brand = eigerConnectionBrandId;

        if(eigerConnectionId === null) {
            // If no already existing credentials : create new api connection
            postControllablePrinterApiConnection(data)
                .then((apiConnectionData) => {
                    successCallback('Connexion créée');
                    setEigerConnectionId(apiConnectionData.id);
                    reset();
                })
                .catch(() => {errorCallback('Une erreur est survenue lors de la création de la connexion')})
        } else {
            // Update existing credentials
            data.id = eigerConnectionId;
            patchControllablePrinterApiConnection(data)
                .then(() => {
                    successCallback('Eiger connection updated');
                    setIsEigerConnectionUpdating(false);
                    reset();
                })
                .catch(() => {errorCallback('Une erreur est survenue lors de la mise à jour de la connexion')})
        }
    }

    /* Delete credentials */
    const handleDeleteCredentials = () => {
        deleteControllablePrinterApiConnection(eigerConnectionId)
            .then(() => {
                successCallback('Connexion supprimée');
                setEigerConnectionId(null);
            })
            .catch(() => errorCallback('Une erreur est survenue lors de la suppression de la connexion'))
    }

    const handleCancelUpdate = () => {
        setIsEigerConnectionUpdating(false);
        reset();
    }

    return(
        <div className="block">
            <h2>Connexion à l'API Eiger</h2>
            {
                /* Case no existing eiger connection and user is admin */
                ((eigerConnectionId === null || isEigerConnectionUpdating) && currentUser.admin) &&
                <form id="eiger-api__form" onSubmit={handleSubmit(onSubmitEigerConnection)}>
                    <div className="api-form">
                        <div>
                            <label htmlFor="f-eiger-access-key">API Access Key</label>
                            <input type="text" id="f-eiger-access-key" name="username" required={true} {...register("username")}/>
                        </div>
                        <div>
                            <label htmlFor="f-eiger-secret-key">API Secret Key</label>
                            <input type="text" id="f-eiger-secret-key" name="password" required={true} {...register("password")}/>
                        </div>
                        <button type="submit" className="api-form-button"><i className="fa fa-check"/> Enregistrer les identifiants</button>
                        {eigerConnectionId !== null &&
                        <button type="button" onClick={() => handleCancelUpdate()} className="api-warning-button">Annuler</button>
                        }
                    </div>
                </form>
            }
            {
                /* Case no existing eiger connection and user is not admin */
                (eigerConnectionId === null && !currentUser.admin) &&
                <p>Pas d'identifiants sauvegardés</p>
            }
            {
                /* Case already existing eiger connection */
                (eigerConnectionId !== null && !isEigerConnectionUpdating) &&
                <div>
                    <p><i className="fa fa-check"/> Identifiants sauvegardés</p>
                    {
                        currentUser.admin &&
                        <div>
                            <button className="api-button api-update-button" onClick={() => setIsEigerConnectionUpdating(true)}>Modifier les identifiants</button>
                            <button className="api-button api-warning-button" onClick={() => handleDeleteCredentials()}>Supprimer les identifiants</button>
                        </div>
                    }
                </div>
            }
        </div>
    );
}
